import HubertCombobox from 'components/HubertUI/HubertCombobox';
import type { ComponentProps } from 'react';
import type { TSelectBase } from 'types/general.types';
import { interviewSummaryBlocksList } from './summaryBlock.constants';

interface Props extends ComponentProps<'div'> {
  isMulti?: boolean;
  list?: TSelectBase[];
  value?: string | string[];
  onValueChange?: (value: string | string[]) => void;
  disabled?: boolean;
  itemName?: string;
  portalContent?: boolean;
  triggerClassName?: string;
}

const InterviewSummaryBlockCombobox = ({
  isMulti = false,
  onValueChange,
  value,
  disabled = false,
  list,
  itemName = 'Summary block',
  portalContent = false,
  triggerClassName,
  ...props
}: Props) => {
  return (
    <div {...props}>
      <HubertCombobox
        itemName={itemName}
        isMulti={isMulti}
        items={list ?? interviewSummaryBlocksList}
        onValueChange={onValueChange}
        value={value}
        disabled={disabled}
        portalContent={portalContent}
        triggerClassName={triggerClassName}
      />
    </div>
  );
};

export default InterviewSummaryBlockCombobox;
